module.exports = __webpack_public_path__ + "static/media/BoroughHallEXTA0006_bg_clean_v001.2a511a1d.webp";